import React, { useMemo } from 'react';
import { v4 as createGuid } from 'uuid';

import { ISpecOfferFeature } from '@r1-frontend/api-domru/spec-offer/v1/spec-offers/dto/ISpecOffer';

import { Monitor } from '@r1-frontend/ui-react/components/svg/devices';
import { Speedometer } from '@r1-frontend/ui-react/components/svg/main';
import { H5 } from '@r1-frontend/ui-react/components/typography/heading';

import * as ST from './styled';

interface IOfferFeaturesProps {
    features: ISpecOfferFeature[],
}

export const OfferFeatures = ({ features }: IOfferFeaturesProps) => {
    const pairs = useMemo(() => {
        return features.reduce<ISpecOfferFeature[][]>((acc, val) => {
            if (acc[acc.length - 1] && acc[acc.length - 1].length === 1) {
                return [...acc.slice(0, -1), [acc[acc.length - 1][0], val]];
            }
            return [...acc, [val]];
        }, []);
    }, [features]);

    if (!features.length && !pairs.length) {
        return null;
    }

    return (
        <ST.FeaturesContainer data-test='lkPromotionalPopup-FeaturesContainer-root'>
            {pairs.map((pair) => (
                <ST.FeatureRow key={createGuid()}>
                    {pair
                        .map(({ type, text }) => {
                            const isSpeed = type === 'speed';
                            const Icon = isSpeed ? Speedometer : Monitor;
                            const key = createGuid();

                            return (
                                <ST.FeatureContainer key={key}>
                                    <ST.FeatureIcon>
                                        <Icon size={24} type={'info'} />
                                    </ST.FeatureIcon>
                                    <H5 $withIndent={false}>{text}</H5>
                                </ST.FeatureContainer>
                            );
                        })
                        .flat()}
                </ST.FeatureRow>
            ))}
        </ST.FeaturesContainer>
    );
};
